import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, CardMedia, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { RetrofitBatteryModalResponse } from 'src/Libs/shop/models'
import { makeStyles } from 'tss-react/mui'
import { J3Onoff } from '@e3dc-react/icons'
import { useTypedSelector } from 'src/State/RootReducer'
import { useDispatch } from 'react-redux'
import { removeRetrofitBattery } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationAction'
import { getImageUrlBySize } from 'src/Libs/shop'
import { ShopImageThumnbailSizes } from 'src/Libs/shop/types'

interface RetrofitBatterySystemConfigurationCardProps {
  selectedRetrofitBattery: RetrofitBatteryModalResponse | null
}

const useStyles = makeStyles()(theme => ({
  mainComponentWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
    marginTop: theme.spacing(2),
  },
  icon: {
    color: theme.palette.text.headerTitle,
    transform: 'rotate(90deg) translateY(-12px)',
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
  },
  productImage: {
    width: '45px',
    maxWidth: '45px',
    height: 'auto',
  },
}))

const QUANTITY_SYMBOL = 'X'

const RetrofitBatterySystemConfigurationCard: React.FC<RetrofitBatterySystemConfigurationCardProps> = ({ selectedRetrofitBattery }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const configuratorItems = useTypedSelector(state => state.systemStorage.items)
  const retrofitBattery = configuratorItems.length > 0 ? configuratorItems[0].configuration.retrofitBattery : null

  const handleBatteryRemove = (): void => {
    if (selectedRetrofitBattery) {
      dispatch(removeRetrofitBattery(selectedRetrofitBattery.product.id))
    }
  }

  return (
    <Stack>
      {retrofitBattery && retrofitBattery.id !== null && (
        <Typography variant="h5" mt={2}>
          {t('shop.system-configure-card.retrofit-battery')}
        </Typography>
      )}
      {selectedRetrofitBattery && (
        <Box className={classes.mainComponentWrapper}>
          <Box className={classes.spaceBetween}>
            <Box>
              <CardMedia
                component="img"
                image={getImageUrlBySize(selectedRetrofitBattery?.product.cover?.media?.thumbnails, ShopImageThumnbailSizes.ExtraSmall)}
                className={classes.productImage}
              />
              <Typography variant="h5" align="center" color="primary">
                {retrofitBattery?.qty + QUANTITY_SYMBOL}
              </Typography>
            </Box>
            {selectedRetrofitBattery.product?.translated && (
              <Typography variant="h4" sx={{ wordBreak: 'break-all' }}>
                {selectedRetrofitBattery.product.translated.name}
              </Typography>
            )}
          </Box>

          <IconButton
            onClick={() => {
              handleBatteryRemove()
            }}
          >
            <J3Onoff fontSize="large" className={classes.icon} />
          </IconButton>
        </Box>
      )}
    </Stack>
  )
}

export default RetrofitBatterySystemConfigurationCard
